var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-card',[_c('div',{staticStyle:{"height":"600px"}},[_c('v-chart',{attrs:{"option":_vm.config}})],1),_c('textarea',{attrs:{"name":"","id":"","cols":"30","rows":"10"}},[_vm._v(_vm._s(JSON.stringify(_vm.series)))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }